import { render, staticRenderFns } from "./form-change-reason-modal.vue?vue&type=template&id=a544658a&scoped=true&"
import script from "./form-change-reason-modal.vue?vue&type=script&lang=js&"
export * from "./form-change-reason-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-change-reason-modal.vue?vue&type=style&index=0&id=a544658a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a544658a",
  null
  
)

component.options.__file = "form-change-reason-modal.vue"
export default component.exports